/* Miss Kay's — motion layer. One IntersectionObserver. Reduced-motion safe.
   Powers: scroll-reveal, count-up stats, seamless marquee, sticky mobile ATC. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn,{once:true});} }

  ready(function () {
    /* ---- Scroll reveal ---- */
    var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-mk-reveal]'));
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      reveals.forEach(function(el){ io.observe(el); });
    }

    /* ---- Count-up ---- */
    var nums = Array.prototype.slice.call(document.querySelectorAll('[data-mk-countup]'));
    function runCount(el){
      var target = parseFloat(el.getAttribute('data-mk-countup')) || 0;
      var suffix = el.getAttribute('data-mk-suffix') || '';
      var dur = 1100, start = null;
      if (reduce) { el.textContent = target + suffix; return; }
      function step(ts){ if(!start) start = ts; var p = Math.min((ts-start)/dur,1);
        var v = Math.round(target * (0.5 - Math.cos(Math.PI*p)/2)); el.textContent = v + suffix;
        if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if (nums.length){
      if (reduce || !('IntersectionObserver' in window)) { nums.forEach(runCount); }
      else {
        var io2 = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting){ runCount(e.target); io2.unobserve(e.target); } });
        }, { threshold: 0.5 });
        nums.forEach(function(el){ io2.observe(el); });
      }
    }

    /* ---- Marquee: duplicate track content for a seamless -50% loop ---- */
    document.querySelectorAll('.mk-marquee__track').forEach(function(track){
      track.innerHTML = track.innerHTML + track.innerHTML;
    });

    /* The sticky mobile add-to-cart block that used to live here has been
       REMOVED (2026-09). Both halves were defective:

       · the visibility half observed [data-mk-atc-anchor], which no longer
         exists anywhere in the theme — dead code. The bar manages its own
         visibility in sections/mk-sticky-atc.liquid.
       · the click half bound a SECOND proxy handler to the same
         [data-mk-atc-proxy] element the section already binds inline, so one
         tap fired realBtn.click() twice — two submit events, the second
         swallowed by product-form.js's aria-disabled guard. Harmless on a good
         day, but it doubled the surface for the races that produced the
         "add to cart did nothing" reports in Shopify's shopper test.

       The section owns this behaviour now. Do not re-add it here. */
  });
})();
